import { useIsFetching } from '@tanstack/react-query';

// What follows a model's id in the queries the engine recomputes on request,
// each of which can take seconds after a change. A save waits for the model's
// other queries, which are quick, and lets these refresh in the background.
const RECOMPUTED = new Set(['projection', 'stress-tests', 'return-band', 'charts', 'years']);

export const isRecomputed = ({ queryKey }: { queryKey: readonly unknown[] }): boolean =>
  RECOMPUTED.has(String(queryKey[4]));

// True while a figure already on screen for this model is being worked out
// again after a change, so the page can say its numbers are about to move.
export function useRecalculating(scenarioId: string): boolean {
  return (
    useIsFetching({
      predicate: query =>
        isRecomputed(query) && query.queryKey[3] === scenarioId && query.state.data !== undefined,
    }) > 0
  );
}
